import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useState } from "react";

import { addVoteAnswer, getVoteBlock } from "../../../../api/article";
import UserStore from "../../../../store/UserStore";

export enum EVoteStatus {
  isNew,
  wasEdited,
}

export interface TVoteData extends VoteResponse {
  status?: EVoteStatus;
}

function VoteRenderer({
  data,
  className,
}: {
  data: TVoteData;
  className?: string;
}) {
  const { votes: userVotes } = UserStore;
  const { title, answers: dataAnswers } = data;
  const [loading, setLoading] = useState(false);
  const [answers, setAnswers] = useState(dataAnswers);
  const [activeAnswerId, setActiveAnswerId] = useState<number | undefined>(
    undefined
  );
  const summaryVotesCounter = useMemo(() => {
    return answers.reduce((sum, answer) => sum + answer.counter, 0) || 1;
  }, [answers]);

  const handleAnswer = async (answer: TVoteData["answers"][0]) => {
    if (typeof activeAnswerId === "undefined" && data.vote_id) {
      addVoteAnswer(data.vote_id, answer.answer_id);
      setAnswers(
        answers.map((item) =>
          item === answer ? { ...item, counter: item.counter + 1 } : item
        )
      );
      setActiveAnswerId(answer.answer_id);
      UserStore.setVote(data.vote_id, answer.answer_id);
    }
  };

  useEffect(() => {
    const initBlock = async () => {
      if (data?.vote_id) {
        setLoading(true);
        const response = await getVoteBlock(+data.vote_id);
        if (response) {
          setAnswers(response.answers);
        }
        setLoading(false);
      }
    };
    initBlock();
  }, [data]);

  useEffect(() => {
    if (data.vote_id) {
      setActiveAnswerId(UserStore.votes[data.vote_id]);
    }
  }, [userVotes, data]);

  if (!data) return <></>;
  if (loading) return <div>Загрузка опроса ...</div>;

  return (
    <article className="widget vote">
      <div className="widget__title-block">
        <small className="widget__subtitle">Опрос сообщества:</small>
        <strong className="widget__title">{title}</strong>
      </div>
      <div className="widget__body vote__body">
        <div className="vote__buttons">
          {answers
            .filter((answer) => answer.label !== "")
            .map((answer) => (
              <div className="vote__btn-block" key={answer.answer_id}>
                <button
                  type="button"
                  className={`vote__btn ${
                    activeAnswerId === answer.answer_id && "is-active"
                  }`}
                  onClick={() => handleAnswer(answer)}
                >
                  <span className="vote__btn-text">{answer.label}</span>
                  {activeAnswerId != null && (
                    <span className="vote__btn-text vote__btn-percent">
                      {`${(
                        (100 * answer.counter) /
                        summaryVotesCounter
                      ).toFixed(2)}%`}
                    </span>
                  )}
                </button>
              </div>
            ))}
        </div>
      </div>
    </article>
  );
}

export default observer(VoteRenderer);
